import { useParams } from 'react-router-dom';
import { Loader } from '@/components/common';
import { StoreServicesTable } from '@/components/store/StoreServicesTable';
import { useDocumentTitle } from '@/hooks/common';
import { useStore } from '@/hooks/store';
import { useRegisterPageContext } from '@/providers/PageContextProvider';
import { StoreServicePage } from './StoreService';

export const StoreServicesPage = () => {
  useDocumentTitle('Store');
  const { serviceName } = useParams();

  const { data, isLoading, error } = useStore();
  const dataReady = !isLoading && !error && data;

  useRegisterPageContext(serviceName === undefined ? data?.services : undefined);

  if (!dataReady) return <Loader />;

  const services = data?.services;

  if (serviceName !== undefined) {
    const service = services?.find((service) => service.name === serviceName);
    if (service) {
      return <StoreServicePage service={service} />;
    }
  }

  return <StoreServicesTable services={services} />;
};
